import { fatorEstoque, arredondar } from './produtoOperacoes'

export function unidadeBase(produto = {}) {
  const unidade = produto.unidadeEstoque || produto.unidadeComercialSigla || produto.unidadeSigla || produto.unidade || produto.unidadeComercial
  return typeof unidade === 'object' ? unidade?.sigla || 'UN' : unidade || 'UN'
}
export function conversoesPermitidas(conversoes = [], sentido = 'SAIDA') {
  return conversoes.filter(c => {
    if (!(sentido === 'ENTRADA' ? c.compra : c.venda)) return false
    try { return fatorEstoque(c) > 0 } catch { return false }
  })
}
export function aplicarUnidade(produto, dados, conversao, sentido = 'SAIDA') {
  const fator = conversao ? fatorEstoque(conversao) : 1
  const quantidade = Number(dados.quantidadeLevada ?? dados.quantidade ?? 1)
  if (!Number.isFinite(quantidade) || quantidade <= 0) throw new Error('Informe uma quantidade maior que zero.')
  const precoBase = Number(dados.valorUnitario ?? produto.precoVenda ?? produto.valorUnitario ?? 0)
  const precoConvertido = sentido === 'ENTRADA' ? conversao?.precoCompra : conversao?.precoVenda
  const valorUnitario = conversao ? (Number(precoConvertido) > 0 ? Number(precoConvertido) : arredondar(precoBase * fator, 6)) : precoBase
  return { ...dados, quantidade, unidade: conversao?.unidade || unidadeBase(produto), valorUnitario, conversaoUnidade: { conversaoId: conversao?.id || null, unidadeEstoque: unidadeBase(produto), unidadeComercial: conversao?.unidade || unidadeBase(produto), fatorEstoque: fator, sentido }, quantidadeEstoque: arredondar(quantidade * fator, 6) }
}
export function quantidadeEmEstoque(item) {
  return arredondar(Number(item.quantidadeLevada ?? item.quantidade ?? 0) * Number(item.conversaoUnidade?.fatorEstoque ?? 1), 6)
}
export function resumoSaldoUnidades(saldo, unidade, conversoes = []) {
  const disponiveis = conversoes.filter(c => c.compra || c.venda).filter(c => { try { return fatorEstoque(c) > 0 } catch { return false } })
  return [{ unidade, saldo: Number(saldo || 0), base: true }, ...disponiveis.map(c => ({ unidade: c.unidade, saldo: arredondar(Number(saldo || 0) / fatorEstoque(c), 6), base: false }))]
}
